import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImageGenerationService } from '../services/image-generation.service';

@Component({
    selector: 'app-generate-image',
    imports: [CommonModule, FormsModule],
    templateUrl: './generate-image.component.html',
    styleUrls: ['./generate-image.component.scss']
})
export class GenerateImageComponent {
  prompt: string = '';
  generatedImageUrl: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';
  selectedModel: string = 'dall-e-3';

  models = [
    { label: 'DALL-E 3', value: 'dall-e-3' },
    { label: 'GPT Image Mini', value: 'gpt-image-1-mini' },
    { label: 'Nano Banana', value: 'gemini-2.5-flash-image' },
  ];

  constructor(private imageGenerationService: ImageGenerationService) {}

  async onSubmit() {
    if (!this.prompt.trim()) {
      this.errorMessage = 'Please enter a prompt';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.generatedImageUrl = '';

    try {
      this.generatedImageUrl = await this.imageGenerationService.generateImage(
        this.prompt,
        '1024x1024',
        'standard',
        'vivid',
        this.selectedModel
      );
    } catch (error: any) {
      this.errorMessage = error?.message || 'Failed to generate image. Please try again.';
      console.error('Image generation error:', error);
    } finally {
      this.isLoading = false;
    }
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSubmit();
    }
  }

  clearImage() {
    this.generatedImageUrl = '';
    this.prompt = '';
    this.errorMessage = '';
  }
}

